<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "fill";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      d="M8.06741 2C6.57811 2 5.37079 3.20732 5.37079 4.69662V20.9887C5.37079 21.3774 5.59361 21.7318 5.94397 21.9001C6.29433 22.0685 6.71019 22.0212 7.01373 21.7784L12 17.7894L16.9862 21.7784C17.2898 22.0212 17.7056 22.0685 18.056 21.9001C18.4064 21.7318 18.6292 21.3774 18.6292 20.9887V4.69662C18.6292 3.20732 17.4219 2 15.9326 2H8.06741ZM7.39326 4.69662C7.39326 4.3243 7.69508 4.02247 8.06741 4.02247H15.9326C16.3049 4.02247 16.6067 4.3243 16.6067 4.69662V18.8847L12.6317 15.7047C12.2624 15.4092 11.7376 15.4092 11.3683 15.7047L7.39326 18.8847V4.69662Z"
    />
    <path
      v-else-if="weight === 'fill'"
      d="M8.06744 2C6.57814 2 5.37082 3.20732 5.37082 4.69662V20.9887C5.37082 21.3774 5.59364 21.7318 5.944 21.9001C6.29436 22.0685 6.71022 22.0212 7.01377 21.7784L12 17.7894L16.9863 21.7784C17.2898 22.0212 17.7057 22.0685 18.056 21.9001C18.4064 21.7318 18.6292 21.3774 18.6292 20.9887V4.69662C18.6292 3.20732 17.4219 2 15.9326 2H8.06744Z"
    />
  </svg>
</template>
